"use client";

interface Props {
  count: number;
  busy: boolean;
  onSchedule: () => void;
  onAddToTodos: () => void;
  onArchive: () => void;
  onClear: () => void;
}

export default function LibraryBulkBar({
  count,
  busy,
  onSchedule,
  onAddToTodos,
  onArchive,
  onClear,
}: Props) {
  if (count <= 0) return null;
  return (
    <div
      data-testid="library-bulk-bar"
      role="toolbar"
      aria-label="Bulk actions for selected library items"
      className="sticky top-2 z-30 flex flex-wrap items-center gap-2 rounded-2xl bg-forest px-4 py-2.5 text-white shadow-lg"
    >
      <span
        data-testid="library-bulk-count"
        className="text-sm font-semibold"
      >
        {count} selected
      </span>
      <button
        type="button"
        data-testid="library-bulk-schedule"
        onClick={onSchedule}
        disabled={busy}
        className="rounded-full bg-white px-3.5 py-1.5 text-[12px] font-semibold text-forest transition-colors hover:bg-cream disabled:opacity-60"
      >
        Add to schedule
      </button>
      <button
        type="button"
        data-testid="library-bulk-todo"
        onClick={onAddToTodos}
        disabled={busy}
        className="rounded-full border border-white/30 bg-transparent px-3.5 py-1.5 text-[12px] font-medium text-white transition-colors hover:bg-white/10 disabled:opacity-60"
      >
        + Add to todos
      </button>
      <span className="flex-1" />
      <button
        type="button"
        data-testid="library-bulk-archive"
        onClick={onArchive}
        disabled={busy}
        className="rounded-full border border-white/30 bg-transparent px-3.5 py-1.5 text-[12px] font-medium text-white transition-colors hover:bg-white/10 disabled:opacity-60"
      >
        Archive
      </button>
      <button
        type="button"
        data-testid="library-bulk-clear"
        onClick={onClear}
        disabled={busy}
        aria-label="Clear selection"
        className="flex h-7 w-7 items-center justify-center rounded-full text-white/80 transition-colors hover:bg-white/10 hover:text-white disabled:opacity-60"
      >
        <svg width="14" height="14" viewBox="0 0 14 14">
          <path d="M3 3l8 8M11 3l-8 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      </button>
    </div>
  );
}
